export default "__VITE_ASSET__274b5072__"